import { FAQS, IMAGES } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, CTABanner } from "@/components/common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  usePageMeta("FAQ", "Frequently asked questions about stucco services, repairs, estimates and more from A.D.N Stucco Inc in Central Florida.");
  return (
    <div data-testid="faq-page">
      <PageHero label="Questions & Answers" title="Frequently asked questions" subtitle="Everything you need to know about our stucco and plastering services. Can't find your answer? Give us a call." image={IMAGES.texture} />
      <section className="py-24 bg-adn-white">
        <div className="max-w-3xl mx-auto px-6">
          <SectionLabel>FAQ</SectionLabel>
          <h2 className="text-4xl font-heading font-extrabold mt-6 mb-10">Common questions</h2>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-zinc-200">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-heading font-bold text-lg hover:text-adn-red hover:no-underline py-6">{f.q}</AccordionTrigger>
                <AccordionContent className="text-zinc-600 text-base leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
